<template>
	<div>
		<div class="row">
			<div class="col-12 align-align-items-end">
				<p class="fuente-encabezado">
					¡Queremos escucharte!
					<br />Ponte en contacto con nosotros.
				</p>
				<div class="d-flex fuente-sucursal-nombre">
					<i class="fa fa-map-marker-alt mr-2"></i>
					<span>Culiac&aacute;n, Sinaloa</span>
				</div>
				<div class="d-flex align-items-start">
					<span class="fuente-direccion">
						Av. Federalismo No. 4767, Col. Infonavit Las Flores, C.P. 80159
						<br />Culiacán Rosales, Sinaloa.
					</span>
				</div>
				<div class="d-flex align-items-start">
					<i class="fa fa-phone-alt mr-2 iconoStyle"></i>
					<span class="fuente-direccion">(667) 715 1900</span>
				</div>
				<div class="d-flex my-2">
					<a href="http://www.facebook.com/difarmermexico">
						<img class="iconoStyle mr-2" src="@/assets/img-pub/facebook.png"/>
						<!--<i class="fab fa-facebook-f mr-2 ml-1 iconoStyle"></i>-->
					</a>
					<a href="http://www.linkedin.com/company/difarmer">
						<img class="iconoStyle mx-2" src="@/assets/img-pub/linkedin.png"/>
						<!--<i class="fab fa-linkedin-in mx-2 iconoStyleIn"></i>-->
					</a>
				</div>
				<iframe
					frameborder="0"
					height="300px"
					src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3622.257121503664!2d-107.43538288455612!3d24.786647654315374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86bcd05fe1489967%3A0xa7e43126e94c570f!2sDifarmer%2C%20S.A.%20de%20C.V.!5e0!3m2!1ses-419!2smx!4v1577206016219!5m2!1ses-419!2smx"
					width="100%"
				></iframe>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		mounted() {
			//this.ocultarChat()
		}
	}
</script>

<style scoped>
	.iconoStyle {
		font-size: 20px;
		color: var(--color-azul);
	}
	.iconoStyleIn {
		font-size: 20px;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.fuente-direccion {
			color: var(--color-gris-dark) !important;
			font-family: "Open Sans";
			font-size: 12px;
			font-weight: normal;
		}
		.fuente-encabezado {
			font-weight: bold;
			color: var(--color-amarillo) !important;
			font-style: italic;
			font-size: 16px;
		}
		.fuente-sucursal-nombre {
			font-size: 18px !important;
			font-family: "Open Sans" !important;
			color: var(--color-azul);
			font-weight: bold;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.fuente-direccion {
			color: var(--color-gris-dark) !important;
			font-family: "Open Sans";
			font-size: 12px;
			font-weight: normal;
		}
		.fuente-encabezado {
			font-weight: bold;
			color: var(--color-amarillo) !important;
			font-style: italic;
			font-size: 16px;
		}
		.fuente-sucursal-nombre {
			font-size: 18px !important;
			font-family: "Open Sans" !important;
			color: var(--color-azul);
			font-weight: bold;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.fuente-direccion {
			color: var(--color-gris-dark) !important;
			font-family: "Open Sans";
			font-size: 12px;
			font-weight: normal;
		}
		.fuente-encabezado {
			font-weight: bold;
			color: var(--color-amarillo) !important;
			font-style: italic;
			font-size: 20px;
		} 
		.fuente-sucursal-nombre {
			font-size: 18px !important;
			font-family: "Open Sans" !important;
			color: var(--color-azul);
			font-weight: bold;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) {
		.fuente-sucursal-nombre {
			font-size: 22px !important;
			font-family: "Open Sans" !important;
			color: var(--color-azul);
			font-weight: bold;
		}
		.fuente-direccion {
			color: var(--color-gris-dark) !important;
			font-family: "Open Sans";
			font-size: 17px;
			font-weight: normal;
		}
		.fuente-encabezado {
			font-weight: bold;
			color: var(--color-amarillo) !important;
			font-style: italic;
			font-size: 26px;
		}
	}
</style>